// @ts-nocheck

export const ADD_ITEM = 'immersive/basket/addItem';
export const SUBMIT = 'immersive/basket/submit';
export const ACCEPT_CHANGE = 'immersive/basket/acceptChange';
export const CLEAR_BASKET_ITEM = 'immersive/basket/clearBasketItem';
export const ON_VALIDATED = 'immersive/basket/onValidated';
export const ON_ERROR = 'immersive/basket/onError';
export const ON_WAITING_TRADER_VALIDATION = 'immersive/basket/onWaitingTraderValidation';
export const ON_TRADER_NOTIFICATION = 'immersive/basket/onTraderNotification';
export const SET_STAKE = 'immersive/basket/setStake';
export const SET_DEFAULT_STAKE = 'immersive/setDefaultStake';
export const SET_SELECTED_BET_GROUP = 'immersive/setSelectedBetGroup';
export const RESET_PANEL_CONTENT = 'immersive/resetPanelContent';

const actionTypes = {
  ADD_ITEM,
  SUBMIT,
  CLEAR_BASKET_ITEM,
  ACCEPT_CHANGE,
  ON_ERROR,
  ON_VALIDATED,
  ON_WAITING_TRADER_VALIDATION,
  SET_SELECTED_BET_GROUP,
  RESET_PANEL_CONTENT,
  ON_TRADER_NOTIFICATION,
  SET_DEFAULT_STAKE,
  SET_STAKE,
};

export default actionTypes;
